export const RetailDemoColumns = [  
    { field: 'storeName', headerName: 'Retailer', width: 180, editable: false, sortable: false },  
    { field: 'productType', headerName: 'Domain', width: 180, editable: false, sortable: false },  
    { field: 'inventory', headerName: 'Status', width: 180, editable: false, sortable: false },  
    { field: 'version', headerName: 'Version', width: 180, editable: false, sortable: false },  
    { field: 'location', headerName: 'Store Location', width: 180, editable: false, sortable: false },  
    { field: 'storeType', headerName: 'Store Type', width: 180, editable: false, sortable: false },  
    { field: 'productCode', headerName: 'ProductCode', width: 180, editable: false, sortable: false },  
];  

export const RetailDemoRows = [  
    {  
        id: 1,  
        storeName: "bloomingdale",  
        productType: "menswear",  
        inventory: "delivered",  
        version: "v1.2",  
        location: "toronto",  
        storeType: "brickAndMortar",  
        productCode: "mw001",  
    },  
    {  
        id: 2,  
        productType: "womenswear",  
        inventory: "orderPlaced",  
        version: "v2.4",  
        location: ">",  
        storeType: "warehouse",  
        productCode: "mw002",  
    },  
    {  
        id: 3,  
        productType: "*",  
        inventory: "backOrdered",  
        version: "v.3.1",  
        location: "ottawa",  
        storeType: "specialty",  
        productCode: "mw003",  
    },  
    {  
        id: 4,  
        productType: "outdoorwear",  
        inventory: "cancelled",  
        version: "*",  
        location: "kingston",  
        storeType: ">",  
        productCode: "*",  
    },  
    {  
        id: 5,  
        productType: "footwear",  
        version: "v9.3",  
        location: "winnipeg",  
        productCode: "mw005",  
    },  
    {  
        id: 6,  
        productType: "accessories",  
        version: "v11.2",  
        productCode: "mw006",  
    },  
    {  
        id: 7,  
        productCode: "mw007",  
    },  
    {  
        id: 8,  
        productCode: "mw008",  
    },  
    {  
        id: 9,  
        productCode: "mw009",  
    },  
    {  
        id: 10,  
        productCode: "mw010",  
    },  
];
